"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toArray = toArray;
function toArray(obj) {
    if (obj === null || obj === undefined) {
        return [];
    }
    return Array.isArray(obj) ? obj : [obj];
}
//# sourceMappingURL=toArray.js.map